import {
  getBasketStatsUseCase,
  basketRepository,
  useBasketStatsStore,
} from '~/domains/basket';

export default function useGetBasketLinesAdapter(): {
  getBasketStats: () => Promise<void>;
} {
  const { updateBasketStats } = useBasketStatsStore();

  const getBasketStats: () => Promise<void> = async () => {
    await getBasketStatsUseCase({
      basketRepository,
      storage: {
        updateBasketStats,
      },
    });
  };

  return {
    getBasketStats,
  };
}
